<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('no')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>账号
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.no"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('name')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>姓名
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('nickname')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>昵称
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.nickname"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('gender')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>性别
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.gender" class="select classification">
                <el-option v-for="item in options_genderType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('email')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>EMail
          </td>
          <td class="after">
            <el-form-item prop="email">
              <el-input v-model="form.email" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('cell')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>手机号码
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.cell" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('telno')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>电话号码
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.telno" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('faxno')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>传真号码
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.faxno" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('address')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>地址
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.address" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('zipcode')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>邮政编码
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.zipcode" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
         <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('zipcode')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属组织
          </td>
          <td class="after">
             <el-form-item>
              <el-select clearable v-model="form.organiseid" placeholder="请选择组织" class="select classification">
                <el-option v-for="item in organisedata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Usergl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/UserUpdate'">确定</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Usergl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/UserUpdate'">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      form: {
        no: '',
        name: '',
        nickname: '',
        gender: '',
        email: '',
        cell: '',
        telno: '',
        faxno: '',
        address: '',
        zipcode: '',
        glid: '1',
        creator: '1',
        organiseid: null
      },
      options_genderType: [
        {
          value: 0,
          label: '男'
        },
        {
          value: 1,
          label: '女'
        }
      ],
      //表名
      tabname: 'user1',
      //fld表数据
      fldData: [],
      organisedata: []
    }
  },
  async created()
  {
    this.getOrganise()
    this.fldData = await window.public.validation(this.tabname)
    this.isgetData()
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 99,
        _minor: 13,
        retAtt: 1,
        no: this.form.no,
        name: this.form.name,
        nickname: this.form.nickname,
        gender: this.form.gender,
        email: this.form.email,
        cell: this.form.cell,
        telno: this.form.telno,
        faxno: this.form.faxno,
        address: this.form.address,
        zipcode: this.form.zipcode,
        glid: this.form.glid,
        creator: this.form.creator,
        ismember: 0,
        organiseid: this.form.organiseid
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    getOrganise()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 126,
        _exp: 'id > 0',
        orderby: 'addtime desc'
      }
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach((item) => this.organisedata.push({ value: item.id, label: item.name }))
        this.organisedata.push({ value: 0, label: '中国东盟矿业信息服务平台和广西海外矿业产业联合会' })
      })
    },
    // 获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/UserUpdate')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 13,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.no = ret[0].no
        this.form.name = ret[0].name
        this.form.nickname = ret[0].nickname
        this.form.gender = ret[0].gender
        this.form.email = ret[0].email
        this.form.cell = ret[0].cell
        this.form.telno = ret[0].telno
        this.form.faxno = ret[0].faxno
        this.form.address = ret[0].address
        this.form.zipcode = ret[0].zipcode
        this.form.glid = ret[0].glid
        this.form.creator = ret[0].creator
        this.form.organiseid = ret[0].organiseid
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 99,
        _minor: 13,
        retAtt: 1,
        id: this.form.id,
        no: this.form.no,
        name: this.form.name,
        nickname: this.form.nickname,
        gender: this.form.gender,
        email: this.form.email,
        cell: this.form.cell,
        telno: this.form.telno,
        faxno: this.form.faxno,
        address: this.form.address,
        zipcode: this.form.zipcode,
        glid: this.form.glid,
        creator: this.form.creator,
        organiseid: this.form.organiseid
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Usergl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.go(-1)
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/UserAdd.vue